<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <h1>Redação Acadêmica Facilitada</h1>
                        <p>Acelere o sucesso da publicação com assistência de redação acadêmica avançada. Trinka aprimora a
                            sua redação para obedecer às convenções e práticas recomendadas de redação acadêmica.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/academic.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>Soluções adequadas à Indústria para</h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>Universidades e Instituições Acadêmicas</li>
                            <li>Sociedades e Associações</li>
                            <li>Institutos de Pesquisa e Desenvolvimento</li>
                            <li>Laboratórios</li>
                            <li>Periódicos e Publicações</li>
                            <li>Bibliotecas</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>Aprovado por Líderes Globais</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/StanfordUniversity.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/MIT.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Yale.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Yonsei_University.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/nippon-institute.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" loading="lazy"  decoding="async" alt="universities" width="180">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>Assistência de Redação de Alta Qualidade para Acadêmicos</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka auxilia seus professores e alunos a entregarem documentos da mais alta qualidade e padrões
                            acadêmicos de forma fácil e oportuna.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/PublicationReadiness.svg" alt="publication readiness" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificações de Prontidão para Publicação</h3>
                                    <p> Trinka verifica os artigos de pesquisa em relação a mais de 20 requisitos de prontidão
                                        para publicação para ajudar as suas equipes a publicarem mais rapidamente, permitindo
                                        que você fortaleça o portfólio de pesquisa da sua marca com mais rapidez.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="medical spell" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificação Ortográfica Acadêmica e Dicionário</h3>
                                    <p>O dicionário acadêmico embutido de Trinka tem milhares de termos de todas as áreas. Você
                                        também pode adicionar o vocabulário da sua organização e novos termos para manter
                                        a consistência em todas as comunicações e personalizar sua assistência na redação
                                    </p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/StyleGuides.png" alt="style guide" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Guias de Estilo Embutidos e Personalizados</h3>
                                    <p>Trinka torna o cumprimento de guias de estilo técnico, como AMA e APA, uma brisa com
                                        correções para todas as preferências de escrita em poucos cliques. Padronize toda
                                        a sua comunicação entre as equipes também com guias de estilo personalizados.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/PublishReadywriting.png" alt="PublishReady" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Redação Pronta para Publicação</h3>
                                    <p>Trinka entende as nuances da redação acadêmica - necessidade de objetividade, concisão,
                                        tom formal e muito mais - para garantir que sua redação atenda aos padrões acadêmicos.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc_icon" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificação de Plágio </h3>
                                    <p>A mais alta qualidade de verificação de plágio, com o algoritmo mais avançado de detecção de semelhança de textos, iThenticate e o maior banco de dados de publicações pagas.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/reference-quality.png" width="40" height="40" alt="reference-quality" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificador de Citações</h3>
                                    <!-- <p>Access management is easy and secure with Trinka’s granular controls for in-house students and distance learners.
                                    </p> -->
                                    <p>Idenfique citações que podem enfraquecer sua premissa de pesquisa e sua argumentação, e faça citações com credibilidade e autoridade no seu artigo.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="Comprehensive Analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Análise Abrangente</h3>
                                    <p>Veja como as suas equipes usam Trinka ou aprofunde-se na atividade de cada usuário com
                                        análises ricas para uma tomada de decisão eficaz.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="Easy User Management" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Fácil Gerenciamento de Usuário</h3>
                                    <p>A conta da sua equipe permite que você gerencie o acesso, troque licenças ou adicione
                                        membros em apenas alguns segundos e automatiza o resto para você.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Suporte Dedicado</h3>
                                    <p>Um Gerente de Sucesso dedicado é designado para apoiar a sua equipe para obter o máximo
                                        de Trinka. Isso inclui uma chamada de integração minuciosa, documentação de ajuda
                                        e orientações em vídeo.
                                    </p>
                                </div>
                            </div>
                        </li>



                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/BulkEditingOperations.svg" alt="bulk editing" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Operações de Edição em Massa</h3>
                                    <p>Carregue os seus documentos em formato MS Word e relaxe enquanto Trinka os edita em minutos.
                                        Basta baixar os arquivos editados e revisar todas as alterações para finalizar o
                                        seu conteúdo.</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>
                    <span class="bottom_diviedLine2"></span>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>Integrações Flexíveis para Cada Caso de uso </h2>
                    <div class="HeadingSubLine"></div>
                    <p>Descubra o verdadeiro poder de Trinka para instituições acadêmicas por meio de recursos personalizados.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Acompanhe o Progresso do Aprendizado</h4>
                                <p>Avalie e acompanhe a melhoria da redação de cada aluno ao longo do tempo com informações
                                    valiosas.
                                </p>
                                <ul>
                                    <li>Escrevendo pontuação de qualidade</li>
                                    <li>Erros por categoria gramatical</li>
                                    <li>Correções feitas</li>
                                    <li>Escrevendo engajamento</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Permite que os Alunos Melhorem as suas Habilidades de Redação Acadêmica</h4>
                                <p>Trinka fornece explicações detalhadas para os erros para ajudar os escritores a aprenderem
                                    práticas de redação acadêmica.
                                </p>
                                <ul>
                                    <li>Encontra erros de escrita complexos</li>
                                    <li>Obtem explicações detalhadas para correções</li>
                                    <li>Oferece dicas para melhorar a redação</li>
                                    <li>Escrevendo pontuação de qualidade para rastrear melhorias</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Ajuda Pesquisadores a Publicarem mais Rapidamente</h4>
                                <p>Trinka foi desenvolvido para ajudá-lo a evitar a rejeição editorial e a publicar mais rapidamente
                                    em periódicos globais.</p>
                                <ul>
                                    <li>Verificações de conformidade técnica (estrutura do papel e integridade)</li>
                                    <li>Verificação do escopo do periódico (ajuda a encontrar o periódico certo)</li>
                                    <li>Guias de estilo integrados</li>
                                    <li>Sugestões de palavras-chave</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Editar Automaticamente Arquivos do MS Word</h4>
                                <p>Trinka permite que você carregue todos os seus documentos de uma só vez e os edita automaticamente
                                    em minutos.</p>
                                <ul>
                                    <li>Arquivos de alteração de faixa permitem controle total</li>
                                    <li>Escrevendo pontuação de qualidade e relatório de erro por categoria</li>
                                    <li>Melhorias de escrita mais rápidas com edições em minutos</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>Integre com seu Software Proprietário e Fluxos de Trabalho</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>As integrações fáceis de Trinka permitem que suas equipes desfrutem de todos os benefícios diretamente no
                    software existente, tornando a escrita eficaz, produtiva e contínua.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>JavaScript</h3>

                    <p>
                        Habilite Trinka para todos os membros de sua equipe simplesmente inserindo um pequeno trecho de código JavaScript (JS) em
                        seu navegador ou qualquer aplicativo.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        O poderoso verificador Trinka API traz Trinka direto para seus aplicativos existentes. Com uma arquitetura de API simples,
                        é fácil de integrar.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Na Premissa</h3>

                    <p>
                        Garanta uma redação eficaz e máxima confidencialidade com Trinka hospedado em sua infraestrutura corporativa, seja em servidores
                        locais ou em nuvem.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Cloud Editor</h3>


                    <p>
                        Use todo o potencial de Trinka em qualquer lugar, com o aplicativo seguro baseado na web.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Suplemento MS Word</h3>
                    <p>
                        Aumente a produtividade de suas equipes com sugestões de redação fornecidas no MS Word.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>Plug-ins no Navegador</h3>
                    <p>
                        Assistência de redação em tempo real em qualquer site da Web por meio de plug-ins para todos os seus navegadores favoritos.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>Preços Personalizados que Funcionam para Você</h2>
                </div>
                <p>Trinka oferece preços flexíveis para usuário ou baseados no uso para atender às suas necessidades exclusivas.
                    <br>Troque de usuário e aplique restrições de uso em tempo real, sem nenhum custo extra.
                    <br>Trabalharemos com você para criar um contrato personalizado sem complicações e uma opção de pagamento
                    único por meio de pedido de compra / fatura.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Seguro e confiável</h3>
                        <p>Trinka coloca a segurança e a privacidade dos dados em primeiro plano. Todos os seus dados são fortemente
                            criptografados e armazenados com segurança - ninguém mais tem acesso aos seus dados. Oferecemos
                            planos exclusivos que eliminam completamente o salvamento de qualquer dado assim que você receber
                            sugestões de redação.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="about ai" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Sobre a AI</h3>
                        <p>Trinka usa as mais recentes técnicas de aprendizado de máquina (ML) e processamento de linguagem
                            natural (PNL) para identificar erros gramaticais e sugerir aprimoramentos de linguagem. Ele é
                            treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1300 áreas, incluindo
                            medicina, ciências biológicas, biologia , ciências físicas, engenharia, humanas, negócios e artes
                            para dar a você as sugestões mais relevantes.</p>
                        <p>Trinka é desenvolvido por uma equipe de lingüistas, editores médicos, cientistas de dados e engenheiros
                            com um profundo desejo de criar um futuro com comunicação sem barreiras.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>Desenvolva habilidades de escrita acadêmica com Trinka</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">Obtenha uma cotação</button>
</div>


<app-enterprise-modal></app-enterprise-modal>